module.exports = __webpack_public_path__ + "static/media/tavernello-512.05558d9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tavernello-512.png
// module id = 786
// module chunks = 0